import type { EntryPoint, EntryPointComponent } from 'react-relay';
import parameters from '@atlassian/jira-relay/src/__generated__/AutomationPopupMenuContentQuery$parameters';
import type { AutomationPopupMenuContentQuery } from '@atlassian/jira-relay/src/__generated__/AutomationPopupMenuContentQuery.graphql';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const automationMenuContentEntrypoint: EntryPoint<
	EntryPointComponent<
		{
			mainQuery: AutomationPopupMenuContentQuery;
		},
		{},
		{
			onClose: () => void;
		},
		{}
	>,
	{
		cloudId: string;
		projectIdOrKey: string;
	}
> = createEntryPoint({
	root: JSResourceForInteraction(() =>
		import(
			/* webpackChunkName: "async-automation-menu-content-entrypoint" */ './ui/AutomationPopupMenuContent'
		).then((module) => module.AutomationPopupMenuContent),
	),
	getPreloadProps: ({ cloudId, projectIdOrKey }: { cloudId: string; projectIdOrKey: string }) => {
		return {
			queries: {
				mainQuery: {
					parameters,
					variables: {
						cloudId,
						projectIdOrKey,
					},
					options: {
						fetchPolicy: 'store-or-network' as const,
					},
				},
			},
		};
	},
});
